var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4692 0H8.53083C3.81938 0 0 3.81938 0 8.53083V31.4692C0 36.1806 3.81938 40 8.53083 40H31.4692C36.1806 40 40 36.1806 40 31.4692V8.53083C40 3.81938 36.1806 0 31.4692 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1663 13.9329C31.2893 14.3212 30.3591 14.576 29.4067 14.6888C30.4028 14.0911 31.1644 13.1478 31.516 12.0287C30.5738 12.5872 29.5435 12.9814 28.4693 13.1947C27.811 12.488 26.955 11.9962 26.013 11.7833C25.071 11.5703 24.0867 11.6463 23.1885 12.0011C22.2902 12.356 21.5198 12.9733 20.9777 13.7725C20.4356 14.5718 20.1469 15.5159 20.1493 16.4817C20.1482 16.8504 20.1895 17.218 20.2724 17.5773C18.3613 17.4815 16.4916 16.9849 14.7848 16.1199C13.0779 15.2549 11.572 14.0407 10.3647 12.5561C9.74708 13.6144 9.55718 14.8686 9.83381 16.0623C10.1105 17.256 10.8327 18.2989 11.8529 18.9776C11.0885 18.9537 10.3411 18.7467 9.67329 18.3741V18.4327C9.67329 20.7646 11.3314 22.7099 13.5286 23.1493C12.8218 23.3422 12.0801 23.3702 11.3607 23.2313C11.668 24.186 12.2656 25.0209 13.0701 25.6196C13.8747 26.2183 14.8461 26.5509 15.8488 26.571C14.8515 27.3549 13.7094 27.9344 12.4878 28.2762C11.2663 28.618 9.98927 28.7155 8.72998 28.5631C10.8568 29.9283 13.3821 30.7192 16.1007 30.7192C24.9479 30.7192 29.7817 23.3954 29.7817 17.0383C29.7817 16.8332 29.7817 16.6281 29.77 16.4172C30.7074 15.7434 31.5277 14.8938 32.1722 13.9329H32.1663Z",
    fill: "#68A678"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFooter);
export default __webpack_public_path__ + "static/media/TwitterFooter.15dfb0f9f4eaa768d1cd1c31a4c6d746.svg";
export { ForwardRef as ReactComponent };